import { factoryImages } from '@components/helpers/imagesImports';

const getGoodIcon = (item: string): string | null => {
  let goodIcon: string | null = null;

  Object.values(factoryImages).forEach((factory) => {
    const icons = factory.icons;

    if (Object.prototype.hasOwnProperty.call(icons, item)) {
      const newIcons = icons as Record<string, string>;
      goodIcon = newIcons[item];
    }
  });

  return goodIcon;
};

export { getGoodIcon };
